// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/singular_day_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/singular_day_model.proto.
 */
export const file_bffuser_v1_singular_day_model: GenFile = /*@__PURE__*/
  fileDesc("CiNiZmZ1c2VyL3YxL3Npbmd1bGFyX2RheV9tb2RlbC5wcm90bxIKYmZmdXNlci52MSK6AwoLU2luZ3VsYXJEYXkSHwoEZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSDAoEbmFtZRgCIAEoCRIuCgpjcmVhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpjcmVhdGVkX2J5GAUgASgJEi4KCnVwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCnVwZGF0ZWRfYnkYByABKAkSMQoIY2F0ZWdvcnkYCCABKA4yHy5iZmZ1c2VyLnYxLlNpbmd1bGFyRGF5Q2F0ZWdvcnkSPgoPZGVtYW5kX2JlaGF2aW9yGAkgASgOMiUuYmZmdXNlci52MS5TaW5ndWxhckRheURlbWFuZEJlaGF2aW9yEhQKAmlkGAogASgJQgi6SAVyA7ABARI8CgphcmVhX2NvZGVzGAsgAygOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCEbpIDpIBCxAKIgeCAQQQASAAEiEKDnNpbmd1bGFyX2dyb3VwGAwgASgFQgm6SAYaBBgKKAFKBAgDEARSBG1lbW8iTQoRU2luZ3VsYXJHcm91cE5hbWUSIQoOc2luZ3VsYXJfZ3JvdXAYASABKAVCCbpIBhoEGAooARIVCgRuYW1lGAIgASgJQge6SARyAhgeKtEBChNTaW5ndWxhckRheUNhdGVnb3J5EiUKIVNJTkdVTEFSX0RBWV9DQVRFR09SWV9VTlNQRUNJRklFRBAAEisKJ1NJTkdVTEFSX0RBWV9DQVRFR09SWV9ZRUFSX0VORF9ORVdfWUVBUhABEh4KGlNJTkdVTEFSX0RBWV9DQVRFR09SWV9PQk9OEAISJQohU0lOR1VMQVJfREFZX0NBVEVHT1JZX0dPTERFTl9XRUVLEAMSHwobU0lOR1VMQVJfREFZX0NBVEVHT1JZX09USEVSEAQq8wEKGVNpbmd1bGFyRGF5RGVtYW5kQmVoYXZpb3ISLAooU0lOR1VMQVJfREFZX0RFTUFORF9CRUhBVklPUl9VTlNQRUNJRklFRBAAEigKJFNJTkdVTEFSX0RBWV9ERU1BTkRfQkVIQVZJT1JfV0VFS0RBWRABEikKJVNJTkdVTEFSX0RBWV9ERU1BTkRfQkVIQVZJT1JfU0FUVVJEQVkQAhIoCiRTSU5HVUxBUl9EQVlfREVNQU5EX0JFSEFWSU9SX0hPTElEQVkQAxIpCiVTSU5HVUxBUl9EQVlfREVNQU5EX0JFSEFWSU9SX1NJTkdVTEFSEARCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * SingularDay mirrors backend internalapi.v1.SingularDay without
 * organization_id.
 *
 * @generated from message bffuser.v1.SingularDay
 */
export type SingularDay = Message<"bffuser.v1.SingularDay"> & {
  /**
   * The singular day's business date (part of the natural-key identity,
   * immutable after creation).
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * Free-text display name (必須, 30 文字以内, spec AC-010).
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: string created_by = 5;
   */
  createdBy: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: string updated_by = 7;
   */
  updatedBy: string;

  /**
   * カテゴリ (年末年始 / お盆 / GW / その他).
   *
   * @generated from field: bffuser.v1.SingularDayCategory category = 8;
   */
  category: SingularDayCategory;

  /**
   * 需要扱い (平日相当 / 土曜相当 / 日祝相当 / 特異).
   *
   * @generated from field: bffuser.v1.SingularDayDemandBehavior demand_behavior = 9;
   */
  demandBehavior: SingularDayDemandBehavior;

  /**
   * Surrogate UUID identity used for update / delete.
   *
   * @generated from field: string id = 10;
   */
  id: string;

  /**
   * Target areas. Empty = all-area-common; 1〜10 の特定エリアは列挙する。
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 11;
   */
  areaCodes: AreaCode[];

  /**
   * 特異グループ番号 (1〜10)。demand_behavior が SINGULAR の時の隔離キー
   * (spec 定義)。demand_behavior に関わらず常に 1〜10 が populate される
   * (既定 1、design Note singular-day-special-group.md D2)。
   *
   * @generated from field: int32 singular_group = 12;
   */
  singularGroup: number;
};

/**
 * Describes the message bffuser.v1.SingularDay.
 * Use `create(SingularDaySchema)` to create a new message.
 */
export const SingularDaySchema: GenMessage<SingularDay> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_model, 0);

/**
 * SingularGroupName mirrors backend internalapi.v1.SingularGroupName (design
 * Note singular-group-names.md). Only 命名済み groups have a row; an
 * unnamed group is represented by the row's absence and the frontend falls
 * back to the generated default label 「特異グループN」.
 *
 * @generated from message bffuser.v1.SingularGroupName
 */
export type SingularGroupName = Message<"bffuser.v1.SingularGroupName"> & {
  /**
   * 特異グループ番号 (1〜10).
   *
   * @generated from field: int32 singular_group = 1;
   */
  singularGroup: number;

  /**
   * 表示名 (任意, 30 文字以内). Empty is only valid as a
   * SaveSingularGroupNames entry (= 既定名に戻す); it never appears in a
   * ListSingularGroupNames response.
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message bffuser.v1.SingularGroupName.
 * Use `create(SingularGroupNameSchema)` to create a new message.
 */
export const SingularGroupNameSchema: GenMessage<SingularGroupName> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_model, 1);

/**
 * SingularDayCategory mirrors backend internalapi.v1.SingularDayCategory.
 * カテゴリは 需要扱い=特異 のときの比較キー (同カテゴリの特異日どうしで比較)。
 *
 * @generated from enum bffuser.v1.SingularDayCategory
 */
export enum SingularDayCategory {
  /**
   * @generated from enum value: SINGULAR_DAY_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 年末年始
   *
   * @generated from enum value: SINGULAR_DAY_CATEGORY_YEAR_END_NEW_YEAR = 1;
   */
  YEAR_END_NEW_YEAR = 1,

  /**
   * お盆
   *
   * @generated from enum value: SINGULAR_DAY_CATEGORY_OBON = 2;
   */
  OBON = 2,

  /**
   * GW
   *
   * @generated from enum value: SINGULAR_DAY_CATEGORY_GOLDEN_WEEK = 3;
   */
  GOLDEN_WEEK = 3,

  /**
   * その他
   *
   * @generated from enum value: SINGULAR_DAY_CATEGORY_OTHER = 4;
   */
  OTHER = 4,
}

/**
 * Describes the enum bffuser.v1.SingularDayCategory.
 */
export const SingularDayCategorySchema: GenEnum<SingularDayCategory> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_singular_day_model, 0);

/**
 * SingularDayDemandBehavior mirrors backend
 * internalapi.v1.SingularDayDemandBehavior (需要扱い: 類似日検索の比較区分)。
 *
 * @generated from enum bffuser.v1.SingularDayDemandBehavior
 */
export enum SingularDayDemandBehavior {
  /**
   * @generated from enum value: SINGULAR_DAY_DEMAND_BEHAVIOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 平日相当
   *
   * @generated from enum value: SINGULAR_DAY_DEMAND_BEHAVIOR_WEEKDAY = 1;
   */
  WEEKDAY = 1,

  /**
   * 土曜相当
   *
   * @generated from enum value: SINGULAR_DAY_DEMAND_BEHAVIOR_SATURDAY = 2;
   */
  SATURDAY = 2,

  /**
   * 日祝相当
   *
   * @generated from enum value: SINGULAR_DAY_DEMAND_BEHAVIOR_HOLIDAY = 3;
   */
  HOLIDAY = 3,

  /**
   * 特異
   *
   * @generated from enum value: SINGULAR_DAY_DEMAND_BEHAVIOR_SINGULAR = 4;
   */
  SINGULAR = 4,
}

/**
 * Describes the enum bffuser.v1.SingularDayDemandBehavior.
 */
export const SingularDayDemandBehaviorSchema: GenEnum<SingularDayDemandBehavior> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_singular_day_model, 1);

